module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    staticClass: "main-page-body favorites-view",
    staticStyle: {
      "max-width": "1442px",
      "padding-top": "60px"
    },
    style: ({
      backgroundColor: _vm.styles.general.background_color
    })
  }, [_c('div', [_c('v-layout', {
    staticStyle: {
      "margin-bottom": "30px"
    },
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "mt-4",
    attrs: {
      "xs12": ""
    }
  }, [_c('h2', {
    staticClass: "page-header",
    staticStyle: {
      "color": "#4a4a4a",
      "font-size": "29px",
      "font-weight": "bolder",
      "text-justify": "auto"
    }
  }, [_vm._v(_vm._s(_vm.pages.favorites.header))])]), _vm._v(" "), _c('v-flex', {
    staticClass: "page-subtitle",
    staticStyle: {
      "color": "#4a4a4a",
      "font-size": "18px",
      "font-weight": "400",
      "margin": "0px"
    },
    attrs: {
      "xs12": ""
    }
  }, [_c('div', {
    staticStyle: {
      "padding-top": "0px"
    }
  }, [_c('p', {
    staticStyle: {
      "text-justify": "auto",
      "line-height": "22px"
    }
  }, [_vm._v("\n              " + _vm._s(_vm.pages.favorites.sub_text) + "\n            ")])])])], 1), _vm._v(" "), _c('v-layout', [_c('v-card', {
    staticStyle: {
      "width": "100%"
    }
  }, [_c('v-tabs', {
    attrs: {
      "slider-color": "primary",
      "grow": _vm.breakpoint === 'xs' || _vm.breakpoint === 'sm'
    }
  }, [_c('v-tab', {
    staticClass: "white",
    staticStyle: {
      "height": "60px",
      "overflow": "none"
    },
    attrs: {
      "light": "",
      "color": "white",
      "href": "#tab-1"
    }
  }, [_c('div', {
    staticStyle: {
      "text-transform": "capitalize",
      "font-size": "16px"
    }
  }, [_c('v-icon', {
    staticClass: "hidden-md-and-up",
    staticStyle: {
      "font-size": "23px"
    },
    attrs: {
      "medium": ""
    }
  }, [_vm._v("people")]), _vm._v(" "), _c('span', {
    staticClass: "hidden-sm-and-down"
  }, [_vm._v("Contractors")]), _vm._v(" (" + _vm._s(_vm.companies.length) + ")\n              ")], 1)]), _vm._v(" "), _c('v-tab', {
    staticClass: "white",
    staticStyle: {
      "height": "60px",
      "overflow": "none"
    },
    attrs: {
      "light": "",
      "color": "white",
      "href": "#tab-2"
    }
  }, [_c('div', {
    staticStyle: {
      "text-transform": "capitalize",
      "font-size": "16px"
    }
  }, [_c('v-icon', {
    staticClass: "hidden-md-and-up",
    staticStyle: {
      "font-size": "23px"
    },
    attrs: {
      "medium": ""
    }
  }, [_vm._v("people")]), _vm._v(" "), _c('span', {
    staticClass: "hidden-sm-and-down"
  }, [_vm._v("Contract History")]), _vm._v(" (" + _vm._s(_vm.contracthistory.length) + ")\n              ")], 1)]), _vm._v(" "), _c('v-tab', {
    staticStyle: {
      "height": "60px",
      "overflow": "none"
    },
    attrs: {
      "light": "",
      "color": "white",
      "href": "#tab-3"
    }
  }, [_c('div', {
    staticStyle: {
      "text-transform": "capitalize",
      "font-size": "16px"
    }
  }, [_c('v-icon', {
    staticClass: "hidden-md-and-up",
    staticStyle: {
      "font-size": "23px"
    },
    attrs: {
      "medium": ""
    }
  }, [_vm._v("date_range")]), _vm._v(" "), _c('span', {
    staticClass: "hidden-sm-and-down"
  }, [_vm._v("Events")]), _vm._v(" (" + _vm._s(_vm.events.length) + ")\n              ")], 1)]), _vm._v(" "), _c('v-tab-item', {
    attrs: {
      "id": "tab-1"
    }
  }, [_c('v-card-text', [_c('v-layout', {
    staticStyle: {
      "height": "100%"
    },
    attrs: {
      "column": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "sm12": "",
      "md12": ""
    }
  }, [_c('v-data-table', {
    attrs: {
      "headers": _vm.tableHeader,
      "items": _vm.companies,
      "loading": _vm.loading,
      "search": _vm.search,
      "rows-per-page-items": [15, 25, 50, 100]
    },
    scopedSlots: _vm._u([{
      key: "items",
      fn: function(props) {
        return [_c('td', {
          staticClass: "text-xs-left"
        }, [_vm._v(_vm._s(props.item.title))]), _vm._v(" "), _c('td', {
          staticClass: "text-xs-left"
        }, [_c('v-layout', [_c('div', [_c('v-tooltip', {
          attrs: {
            "top": ""
          }
        }, [_c('v-btn', {
          staticClass: "blue--text",
          attrs: {
            "slot": "activator",
            "href": props.item.link,
            "target": "_blank",
            "icon": ""
          },
          slot: "activator"
        }, [_c('v-icon', [_vm._v("remove_red_eye")])], 1), _vm._v(" "), _c('span', [_vm._v("View favorite")])], 1)], 1), _vm._v(" "), _c('div', [_c('v-tooltip', {
          attrs: {
            "top": ""
          }
        }, [_c('v-btn', {
          staticClass: "red--text",
          attrs: {
            "slot": "activator",
            "icon": ""
          },
          on: {
            "click": function($event) {
              $event.preventDefault();
              return _vm.removeFavorite(props.item.firebaseRef)
            }
          },
          slot: "activator"
        }, [_c('v-icon', [_vm._v("clear")])], 1), _vm._v(" "), _c('span', [_vm._v("Remove favorite")])], 1)], 1)])], 1)]
      }
    }])
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-tab-item', {
    attrs: {
      "id": "tab-2"
    }
  }, [_c('v-card-text', [_c('v-layout', {
    staticStyle: {
      "height": "100%"
    },
    attrs: {
      "column": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "sm12": "",
      "md12": ""
    }
  }, [_c('v-data-table', {
    attrs: {
      "headers": _vm.historyHeader,
      "items": _vm.contracthistory,
      "loading": _vm.loading,
      "search": _vm.search,
      "rows-per-page-items": [15, 25, 50, 100]
    },
    scopedSlots: _vm._u([{
      key: "items",
      fn: function(props) {
        return [_c('td', {
          staticClass: "text-xs-left"
        }, [_vm._v(_vm._s(props.item.title))]), _vm._v(" "), _c('td', {
          staticClass: "text-xs-left"
        }, [_c('v-layout', [_c('div', [_c('v-tooltip', {
          attrs: {
            "top": ""
          }
        }, [_c('v-btn', {
          staticClass: "blue--text",
          attrs: {
            "slot": "activator",
            "href": props.item.link,
            "target": "_blank",
            "icon": ""
          },
          slot: "activator"
        }, [_c('v-icon', [_vm._v("remove_red_eye")])], 1), _vm._v(" "), _c('span', [_vm._v("View favorite")])], 1)], 1), _vm._v(" "), _c('div', [_c('v-tooltip', {
          attrs: {
            "top": ""
          }
        }, [_c('v-btn', {
          staticClass: "red--text",
          attrs: {
            "slot": "activator",
            "icon": ""
          },
          on: {
            "click": function($event) {
              $event.preventDefault();
              return _vm.removeFavorite(props.item.firebaseRef)
            }
          },
          slot: "activator"
        }, [_c('v-icon', [_vm._v("clear")])], 1), _vm._v(" "), _c('span', [_vm._v("Remove favorite")])], 1)], 1)])], 1)]
      }
    }])
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-tab-item', {
    attrs: {
      "id": "tab-3"
    }
  }, [_c('v-card-text', [_c('v-layout', {
    staticStyle: {
      "height": "100%"
    },
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "sm12": "",
      "md12": ""
    }
  }, [_c('v-data-table', {
    attrs: {
      "headers": _vm.tableHeader,
      "items": _vm.events,
      "rows-per-page-items": [15, 25, 50, 100],
      "loading": _vm.loading,
      "search": _vm.search
    },
    scopedSlots: _vm._u([{
      key: "items",
      fn: function(props) {
        return [_c('td', {
          staticClass: "text-xs-left"
        }, [_vm._v(_vm._s(props.item.title))]), _vm._v(" "), _c('td', {
          staticClass: "text-xs-left"
        }, [_c('v-layout', [_c('div', [_c('v-tooltip', {
          attrs: {
            "top": ""
          }
        }, [_c('v-btn', {
          staticClass: "blue--text",
          attrs: {
            "slot": "activator",
            "href": props.item.link,
            "target": "_blank",
            "icon": ""
          },
          slot: "activator"
        }, [_c('v-icon', [_vm._v("remove_red_eye")])], 1), _vm._v(" "), _c('span', [_vm._v("View favorite")])], 1)], 1), _vm._v(" "), _c('div', [_c('v-tooltip', {
          attrs: {
            "top": ""
          }
        }, [_c('v-btn', {
          staticClass: "red--text",
          attrs: {
            "slot": "activator",
            "icon": ""
          },
          on: {
            "click": function($event) {
              $event.preventDefault();
              return _vm.removeFavorite(props.item.firebaseRef)
            }
          },
          slot: "activator"
        }, [_c('v-icon', [_vm._v("clear")])], 1), _vm._v(" "), _c('span', [_vm._v("Remove favorite")])], 1)], 1)])], 1)]
      }
    }])
  })], 1)], 1)], 1)], 1)], 1)], 1)], 1)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-54ce1c37","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/FavoritesView.vue
// module id = 1685
// module chunks = 22